import styled from '@emotion/styled';
import Container from '@ep/components/Container';
import GridFilter from '@ep/components/GridFilter';
import Layout from '@ep/components/Layout';
import SEO from '@ep/components/Seo';
import HeroVideoModule from '@ep/modules/HeroVideoModule';
import PostGridModule from '@ep/modules/PostGridModule';
import theme from '@ep/theme';
import {
  Gcms_Asset,
  Gcms_LegalAndComplianceLandingPage,
  Gcms_Post,
} from '@ep/types/gatsbyTypes';
import getSeoProps from '@ep/utils/getSeoProps';
import useQueryParam from '@ep/utils/useQueryParams';
import { WindowLocation } from '@reach/router';
import { graphql } from 'gatsby';
import React, { useState } from 'react';

export interface LegalAndComplianceLandingPageProps {
  location: WindowLocation;
  data: {
    gcms: {
      legalAndComplianceLandingPage: Gcms_LegalAndComplianceLandingPage;
      recentPosts: Gcms_Post[];
      legalAndComplianceCuratedPosts: Gcms_Post[];
      heroBackground: Gcms_Asset;
    };
  };
}

const StyledGridDiv = styled.div`
  padding: 3rem 0;
  background-color: ${theme.colors.lightGray};
`;

const GridContainer = styled(Container)``;

// const StyledDiv = styled('div')`
//   background-color: ${theme.colors.lightGray};
// `;

function LegalAndComplianceLandingPage({
  location,
  data,
}: LegalAndComplianceLandingPageProps) {
  const page = data.gcms.legalAndComplianceLandingPage;
  const { legalAndComplianceCuratedPosts, recentPosts } = data.gcms;
  const [tableData, setTableData] = useState(recentPosts);

  return (
    <Layout pathname={location.pathname}>
      <SEO {...getSeoProps(page)} />
      {/* <StyledDiv> */}
      {/* <HeroCTAModule
          {...(getModuleProps(page, 'hero') as HeroCTAModuleProps)}
          labelColor={colors.dark}
        /> */}
      <HeroVideoModule
        label={page.heroHeading}
        heading={page.heroSubheading.html
          .replace(/<[^>]+>/g, '')
          .replace(/&#39;/g, "'")}
        image={page.heroBackground}
        buttonLabel={page.heroButtonLabel}
        buttonLink={page.heroButtonLink}
      />
      {/* </StyledDiv> */}
      <StyledGridDiv>
        <div id={'gridTop'} />
        <GridContainer>
          <GridFilter
            defaultTableData={recentPosts}
            tableData={tableData}
            setTableData={setTableData}
            defaultTopic={useQueryParam('topic', '')[0]}
          />
          <PostGridModule posts={tableData} />
        </GridContainer>
      </StyledGridDiv>
    </Layout>
  );
}

export const query = graphql`
  query LegalAndComplianceLandingPageQuery($id: ID!) {
    gcms {
      legalAndComplianceLandingPage(where: { id: $id }) {
        title
        description
        structuredData
        slug
        featuredImage {
          url
          altText
        }
        heroRight
        heroLabel
        heroHeading
        heroSubheading {
          html
        }
        heroButtonLabel
        heroButtonLink
        heroBackground {
          url
          altText
          vidyardLink
        }
        heroIcon {
          url
          altText
          vidyardLink
        }
      }
      recentPosts: posts(
        where: { postType: Legal_And_Compliance }
        orderBy: displayDate_DESC
      ) {
        id
        displayDate
        title
        hideTitle
        description
        slug
        postType
        postTopic
        postTags
        displayDate
        featuredImage {
          url
          altText
          vidyardLink
        }
      }
    }
  }
`;

export default LegalAndComplianceLandingPage;
